<template>
    <div class="container">
        <div class="row">
            <div class="col-lg-9" v-html="content"></div>
            <div class="col-lg-3">
                <a href="http://www.gnu.org/licenses/" target="_blank">
                    <img src="/static/img/license/Osi_standard_logo.png" class="img-fluid rounded" alt="bush10">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    var marked = require("marked")
    marked.setOptions({
        headerIds: false
    });

    import content from '../pages_content/license.md';

    export default {
        name: 'License',
        data() {
            return {
                content: this.md(content)
            }
        },
        methods: {
            md: function(val){
                return marked(val);
            }
        }
    }
</script>

<style scoped>
    .container {
        margin-top: 115px;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/License.vue